import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { TOMOS, TOMO_FEATURES } from './salesData';
import { HERO_IMAGE_URL } from '../utils/headMeta';
const TOMOS_IMG = HERO_IMAGE_URL;
export function TomosSection() {
  return <section id="tomos" className="bg-ivory py-12 sm:py-16" data-id="element-237" data-mp="1u2wqfa61bi5f">
      <div className="mx-auto max-w-5xl px-5" data-id="element-238" data-mp="1u4hkyzscn13a">
        <div className="text-center" data-id="element-239" data-mp="xdfnh2yfsa7f">
          <SectionTag data-id="element-240" data-mp="xeh2fiikpguf">Qué recibís</SectionTag>
          <h2 className="mt-4 font-display text-[1.5rem] font-bold uppercase leading-tight text-charcoal sm:text-[2.3rem]" data-id="element-241" data-mp="11d7p0vpexg3a">
            Todo lo que recibís dentro de
            <span className="mt-1 block text-gold-deep" data-id="element-242" data-mp="1bc5lqlwzsfxd">Coach Digital PRO</span>
          </h2>
          <p className="mx-auto mt-3 max-w-2xl font-sans text-[0.9rem] leading-relaxed text-charcoal/70 sm:text-base" data-id="element-243" data-mp="1b9svzmkzt19r">
            6 tomos que resuelven, uno por uno, los puntos donde hoy se pierde tu trabajo: cómo te
            ven, qué ofrecés, qué publicás y cómo llegan las consultas.
          </p>
        </div>

        <img src={TOMOS_IMG} alt="Los seis tomos del Mega Pack Coach Digital PRO: Arquitectura de Autoridad, Ingeniería de Oferta Irresistible, Contenido de Alto Rendimiento, Reels & Video Authority, El Sistema de Captación y El Calendario Estratégico PRO" width={1024} height={1024} loading="lazy" decoding="async" sizes="(max-width: 640px) 82vw, 420px" style={{
        aspectRatio: '1024 / 1024'
      }} className="mx-auto mt-6 block h-auto w-[82%] max-w-[420px] rounded-2xl border border-stone object-cover" data-id="element-244" data-mp="2mmwt5au3718v" />

        <div className="mt-7 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-245" data-mp="1ty80m073k48q">
          {TOMOS.map((tomo, i) => <motion.article key={tomo.num} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: i * 0.04
        }} className="flex h-full flex-col rounded-2xl border border-stone bg-sand p-5 transition-colors hover:border-gold/60" data-id="element-246" data-mp="1ozej7woovt3a" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-247" data-mp="11cjc2plf7a5n">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-charcoal font-sans text-[0.72rem] font-bold tabular-nums text-ivory" data-id="element-248" data-mp="15d3arxln6ltw">
                  {tomo.num}
                </span>
                <p className="font-sans text-[0.58rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-249" data-mp="1y2a50ke2cp9c">
                  Tomo {Number(tomo.num)}
                </p>
              </div>

              <h3 className="mt-3 font-display text-[1.05rem] font-bold uppercase leading-tight text-charcoal" data-id="element-250" data-mp="1obp8r3lv3wtl">
                {tomo.title}
              </h3>
              <p className="mt-1.5 font-sans text-[0.82rem] leading-relaxed text-charcoal/70" data-id="element-251" data-mp="2bzf94eu7ve1y">
                {tomo.outcome}
              </p>

              <ul className="mt-3.5 space-y-1.5 border-t border-stone pt-3.5" data-id="element-252" data-mp="5crc0hw6wx37">
                {tomo.points.map(point => <li key={point} className="flex items-start gap-2" data-id="element-253" data-mp="detuag9ke6y">
                    <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-gold" aria-hidden data-id="element-254" data-mp="f3m07rszy6ra" />
                    <span className="font-sans text-[0.78rem] leading-snug text-charcoal/75" data-id="element-255" data-mp="a3g70772wc73">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </motion.article>)}
        </div>

        <div className="mt-6 rounded-2xl border border-gold/40 bg-gold-soft/40 px-5 py-5 text-center" data-id="element-256" data-mp="3dmsvvhv04r6b">
          <p className="mx-auto max-w-2xl font-sans text-[0.9rem] font-medium leading-relaxed text-charcoal sm:text-base" data-id="element-257" data-mp="3sfmfnfhb3tgs">
            No son seis ebooks sueltos. Es un sistema diseñado para ayudarte a ordenar tu presencia
            digital, comunicar mejor lo que hacés y convertir tu conocimiento en oportunidades de
            negocio.
          </p>
        </div>

        <div id="incluye" className="mt-6 rounded-2xl border border-stone bg-sand p-5 sm:p-6" data-id="element-258" data-mp="38iifdyqqzh1h">
          <h3 className="text-center font-display text-base font-bold uppercase text-charcoal sm:text-lg" data-id="element-259" data-mp="3dgk7f965iqp3">
            Cada tomo incluye
          </h3>
          <ul className="mt-4 grid gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-260" data-mp="3mggs6zpf75ev">
            {TOMO_FEATURES.map(f => <li key={f} className="flex items-start gap-2" data-id="element-261" data-mp="3rgbeepy936tl">
                <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-gold" aria-hidden data-id="element-262" data-mp="3rdz0qozizimc" />
                <span className="font-sans text-[0.82rem] leading-snug text-charcoal/75" data-id="element-263" data-mp="7e2ak7558fa">{f}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}